import axios from 'axios';

// Base URL for the backend API
const API_BASE_URL = process.env.REACT_APP_API_URL;

// Create axios instance
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Flag to prevent multiple simultaneous logout redirects
let isRedirecting = false;

// Request interceptor to add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    console.log('BrightLaptopUI API Request Interceptor - URL:', config.url);
    console.log('BrightLaptopUI API Request Interceptor - Token found in localStorage:', !!token);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn('BrightLaptopUI API Request Interceptor - NO TOKEN FOUND in localStorage');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Prevent multiple simultaneous redirects
      if (!isRedirecting) {
        isRedirecting = true;

        // Clear token and user data
        localStorage.removeItem('token');
        localStorage.removeItem('user');

        // Only redirect if not already on login page
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        } else {
          // Reset flag after a delay if already on login page
          setTimeout(() => {
            isRedirecting = false;
          }, 1000);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;

